import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const scratchSlice = createSlice({
    name: 'scratch',
    initialState: {
        token: null,
    },
    reducers: {
        setToken: (state, action) => {
            state.token = action.payload;
        },
    },
});

export const {
    setToken,
    setFallbackToken,
    setSessionId,
    setMsisdn,
    setWallet
} = scratchSlice.actions;

export const getTokenScratch = () => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/user-api/users/demoTest12?language=en`;
    return async (dispatch) => {
        const requestBody = {
            password: "demoTest1234",
            type: "Web",
        };
        try {
            const res = await axios.post(url, requestBody);
            console.log("res.data.status", res.data.status);

            if (res.data.status === 1) {
                const token = res.data.token;
                dispatch(setToken(token));
            }
        } catch (error) {
            console.error(" API Error:", error);
        }
    };
};


export default scratchSlice.reducer;
